import { Link } from 'react-router-dom'

type Props = {
  title: string
  aside?: string
  href?: string
  compact?: boolean
  bordered?: boolean
}

export default function SectionHead({
  title,
  aside,
  href,
  compact = false,
  bordered = true,
}: Props) {
  const spacing = bordered
    ? compact
      ? 'mb-2 border-b border-rule pb-2.5'
      : 'mb-6 border-b border-rule pb-[18px]'
    : 'mb-1.5'

  return (
    <div data-reveal={!compact || undefined} className={`flex min-w-0 items-baseline justify-between gap-3 sm:gap-4 ${spacing}`}>
      <h2 className="text-caps-h2 m-0 min-w-0 text-ink">{title}</h2>
      {href && aside ? (
        <Link to={href} className="text-caps-sm shrink-0 text-rose hover:text-ink">
          {aside}
        </Link>
      ) : aside ? (
        <span className="text-caps-sm shrink-0 text-muted">{aside}</span>
      ) : null}
    </div>
  )
}
